import React, { createContext, useCallback, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { shellAwarePath } from '../shared/ui/roleShell';

const CreateCourseChoiceContext = createContext(null);

/** Opens the course-type picker inside the active shell when possible. */
export function CreateCourseChoiceProvider({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const openCreateCourseChoice = useCallback((extraState = {}) => {
        const from = `${location.pathname}${location.search || ''}`;
        const target = shellAwarePath('/create-choice', location.pathname);
        navigate(target, { state: { from, ...extraState } });
    }, [navigate, location.pathname, location.search]);

    const value = { openCreateCourseChoice };

    return (
        <CreateCourseChoiceContext.Provider value={value}>
            {children}
        </CreateCourseChoiceContext.Provider>
    );
}

export function useCreateCourseChoice() {
    const ctx = useContext(CreateCourseChoiceContext);
    if (!ctx) {
        throw new Error('useCreateCourseChoice must be used within CreateCourseChoiceProvider');
    }
    return ctx;
}

export function useCreateCourseChoiceOptional() {
    return useContext(CreateCourseChoiceContext);
}
